module.exports = __webpack_public_path__ + "static/media/viraj_nalbalwar.f05a259c.png";